import { render } from "./PhoneNumber.vue?vue&type=template&id=150110f1"
import script from "./PhoneNumber.vue?vue&type=script&lang=ts"
export * from "./PhoneNumber.vue?vue&type=script&lang=ts"

import "./PhoneNumber.vue?vue&type=style&index=0&id=150110f1&lang=css"
script.render = render

export default script